// extracted by mini-css-extract-plugin
export default {"history-rewards-error":"styles_history-rewards-error__Aqxka"};